import { useEffect, useState } from "react";

const useVisibilityWithOutsideClick = (ref: React.RefObject<HTMLElement>) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (!isVisible) {
            return;
        }

        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setIsVisible(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isVisible, ref]);

    const onShow = () => setIsVisible(true);
    const onHide = () => setIsVisible(false);

    return { isVisible, onShow, onHide };
};

export default useVisibilityWithOutsideClick;
